import { useQuery } from '@tanstack/react-query';
import { requestCountries, requestStateProvinces } from '../resources/resources';
import { Country } from '../resources/types/Country';
import { StateProvince } from '../resources/types/StateProvince';

export const useCountries = () => {
    return useQuery<Country[]>({
        queryKey: ['countries'],
        queryFn: async ({ signal }) => {
            return (await requestCountries(signal)).data;
        },
        gcTime: Infinity,
    });
};

export const useStateProvinces = (countryCode: string | undefined) => {
    return useQuery<StateProvince[]>({
        queryKey: ['statesProvinces', countryCode],
        queryFn: async ({ signal }) => {
            return (await requestStateProvinces(countryCode, signal)).data;
        },
        enabled: !!countryCode,
        gcTime: Infinity,
    });
};
